import list from 'src/modules/workflow/list/workflowListReducers';
import form from 'src/modules/workflow/form/workflowFormReducers';
import view from 'src/modules/workflow/view/workflowViewReducers';
import destroy from 'src/modules/workflow/destroy/workflowDestroyReducers';
import importerReducer from 'src/modules/workflow/importer/workflowImporterReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  importer: importerReducer,
});
